import * as PropTypes from 'prop-types';
import * as React from 'react';
import { trackInteraction, ARTICLE_TYPE } from '@reverbdotcom/commons/dist/tracker';

class RelatedArticle extends React.Component {
  get categoryName() {
    return this.props.article.categories
      && this.props.article.categories[0]
      && this.props.article.categories[0].name;
  }

  trackClick() {
    trackInteraction({
      componentName: 'RelatedArticleCard',
      url: this.props.article._links.web.href,
      type: ARTICLE_TYPE,
      entityId: `${this.props.article.id}`,
    });
  }

  render() {
    return (
      <article className="article-condensed-card">
        <a
          href={this.props.article._links.web.href}
          style={{ backgroundImage: `url(${this.props.article.photo})` }}
          onClick={() => this.trackClick()}
        >
          <div className="article-condensed-card__title">
            {this.props.article.title}
          </div>
          <div className="article-condensed-card__category">
            {this.categoryName}
          </div>
        </a>
      </article>
    );
  }
}

RelatedArticle.propTypes = {
  article: PropTypes.object.isRequired,
};

export default RelatedArticle;



// WEBPACK FOOTER //
// ./javascripts/components/shared/related_article.jsx